import _ from 'lodash';
import EventMg, { EventType } from '../utilities/EventManager';
import * as inputs from './inputObjects';
import Joi from 'joi-browser';
import { localize, localizeMessage } from '../utilities/validateMessage';
import regex from '../utilities/validateRegex';
import { validationRegexByJoi } from '../utilities/commonValidation';

export const FormUtil = () => {
  return Class => {
    return class extends Class {
      constructor(props) {
        super(props);
        this.min15Flag = false; //入力15分単位
        this.inputMin15Delegate = [];
        this.observer;
      }

      /**
       * フォーム要素の変化を検知
       * 主にkeyupでとれないものをカバーする
       */
      initHiddenObserver() {
        this.observer = new MutationObserver(mutations => {
          mutations.forEach(mutation => {
            if (mutation.target) {
              this.validateElement(mutation.target);
            }
          });
        });
        const _formelements = this.document.querySelectorAll(
          'input,select,textarea,.enableMutation'
        );
        _.each(_formelements, elem => {
          this.addObserve(elem);
        });
        _.each(_formelements, elem => {
          //console.log("@@@@@ _formelements.elem ==" , elem);
          this.addObserveEvent(elem);
        });
      }

      addObserve(elem) {
        this.observer.observe(elem, {
          attributes: true,
          childList: true,
          characterData: true,
        });
      }

      removeObserve(elem) {
        this.observer.observe(elem, {
          attributes: false,
          childList: false,
          characterData: true,
        });
      }

      addObserveEvent(elem) {
        let event;
        if (elem.type === 'hidden') {
          event = 'change';
        } else if (elem.type === 'text') {
          event = 'keyup';
        } else if (elem.type === 'checkbox') {
          event = 'change';
        } else if (elem.type === 'raido') {
          event = 'change';
        } else if (elem.type === 'select-one') {
          event = 'change';
        } else if (elem.type === 'select-multiple') {
          event = 'change';
        } else if (elem.type === 'textarea') {
          event = 'keyup';
        }

        const target = _.filter(this.schema._inner.children, val => {
          //console.log("@@@@@ schema._inner.children ==" , val.key , elem.name );
          return val.key == elem.name;
        });

        if (target.length) {
          elem.addEventListener(event, e => {
            if (e.target) {
              this.validateElement(e.target);
            }
          });
        }
      }

      removeObserveEvent(elem) {
        let event;
        if (elem.type === 'hidden') {
          event = 'change';
        } else if (elem.type === 'text') {
          event = 'keyup';
        } else if (elem.type === 'checkbox') {
          event = 'change';
        } else if (elem.type === 'raido') {
          event = 'change';
        } else if (elem.type === 'select-one') {
          event = 'change';
        } else if (elem.type === 'select-multiple') {
          event = 'change';
        } else if (elem.type === 'textarea') {
          event = 'keyup';
        }
        const target = _.filter(this.schema._inner.children, val => {
          return val.key == elem.name;
        });

        if (target.length) {
          elem.removeEventListener(event, e => {
            if (e.target) {
              this.validateElement(e.target);
            }
          });
        }
      }

      validateElement(target) {
        let _message = '';
        this.getValue(data => {
          if (_.has(data, 'postal_code') && data.postal_code === '-') {
            data.postal_code = '';
          }
          if (_.has(data, 'tel') && data.tel === '--') {
            data.tel = '';
          }
          if (_.has(data, 'job_id') && data.jbo_id === undefined) {
            data.job_id = 0;
          }
          let emptyFlags = {};
          const result = Joi.validate(data, this.schema, {
            abortEarly: false,
            language: localize,
          });
          let targetErrorFlag = false;
          if (result.error) {
            result.error.details.forEach(detail => {
              _.each(detail.path, val => {
                if (detail.type.indexOf('empty') > 0) {
                  emptyFlags[val] = true;
                }
                if (target.name == val) {
                  targetErrorFlag = true;
                  let ms = '';
                  const mt = detail.message.match(/\[(.*)\]/i);
                  const _regex = detail.type.match(/regex/i);
                  if (_regex) {
                    let _pattern = '';
                    _.each(regex.pattern, (value, key) => {
                      if (`${value}` == `${detail.context.pattern}`) {
                        _pattern = key;
                      }
                    });
                    ms = regex.message[_pattern];
                  } else {
                    if (mt) {
                      if (
                        mt[1] == 'string_base' ||
                        mt[1] == 'string_min' ||
                        mt[1] == 'string_max'
                      ) {
                        // const mt2 = detail.message.match(/\[(.*)\]\<([+-]?\d+)\>/i);
                        // eslint-disable-next-line no-unused-vars
                        const mt2 = detail.message.match(/\[(.*)\](d+)/i);
                        ms = `${detail.context.limit}${localizeMessage[mt[1]]}`;
                      } else {
                        ms = `${localizeMessage[mt[1]]}`;
                      }
                    }
                  }
                  // console.log('ms = ', ms, target);
                  const component = this.getFormListElement(
                    this.getFormElementByName(target.name)
                  );
                  if (component) {
                    const message = component.querySelector(
                      '.form-list__alert'
                    );
                    _message = ms;
                    if (_message) {
                      if (!emptyFlags[val]) {
                        message.classList.add('show');
                        if (mt && component) {
                          message.innerText = ms ? ms : localizeMessage[mt[1]];
                        } else if (ms && component) {
                          message.innerText = ms;
                        }
                      } else {
                        if (mt && component) {
                          message.classList.add('show');
                          message.innerText = localizeMessage['empty'];
                        }
                      }
                    } else {
                      message.classList.remove('show');
                    }
                  }
                }
              });
            });
            if (!targetErrorFlag) {
              //if target has no error, remove the error message
              const component = this.getFormListElement(
                this.getFormElementByName(target.name)
              );
              if (component) {
                const message = component.querySelector('.form-list__alert');
                message.classList.remove('show');
              }
            }
          }
        });
      }

      /**
       * ここでフォームにクラス名をつける
       *
       */
      initClassName() {
        const inputlist = ['input', 'select', 'textarea'];
        _.each(inputlist, tag => {
          _.each(document.getElementsByTagName(tag), _tag => {
            if (_tag.name) {
              const _name = _tag.name.replace(/\s+/g, '');
              _tag.classList.add(`sys-key-${_name}`, 'sys-name');
            }
          });
        });
      }

      /**
       * フォームのnameは全て .sys-key-name経由でとる
       * @param {string} name
       */

      getFormElementByName(name) {
        return document.querySelector(
          `.sys-splitview-${this.props.vw || '1'} .sys-key-${name}`
        );
      }

      getFormElementByNameAll(name) {
        return document.querySelectorAll(
          `.sys-splitview-${this.props.vw || '1'} .sys-key-${name}`
        );
      }

      /***
       * フォームに一括して値を設定
       */
      setValue(data, schema) {
        if (!this.forms) {
          this.forms = {};
        }
        //console.log("値を設定 ========",data);
        _.each(data, (value, key) => {
          //console.log("値を設定 = ",key , value , this.getFormElementByName(key));

          if (this.getFormElementByName(key)) {
            var _input = this.getFormElementByName(key);
            if (_input) {
              //inputインスタンス
              //対象になるコンポーネントのセレクタ
              //select-one/select-multiがクラス名に使えないのでエスケープする
              let type = _input.type;
              if (
                _input.type === 'select-one' ||
                _input.type === 'select-multi'
              ) {
                type = 'select';
              }
              var inputObject = new inputs[type](this);
              inputObject.setFormComponent('.form-list__item');
              inputObject.setValue({ value, name: key, schema });
              this.forms[key] = inputObject;
            }
          }
        });
      }

      /**
       * 合計バリデーション
       */
      validateAll(data) {
        // console.log('formUtil.js validateAll', data);
        _.each(this.document.querySelectorAll('.form-list__alert'), elem => {
          elem.classList.remove('show');
        });

        // eslint-disable-next-line no-unused-vars
        let counter = 0;
        let emptyFlags = {};
        const result = Joi.validate(data, this.schema, {
          abortEarly: false,
          language: localize,
          allowUnknown: true,
        });
        if (result.error) {
          result.error.details.forEach(detail => {
            _.each(detail.path, val => {
              // eslint-disable-next-line prettier/prettier
              // console.log("### ",val , detail.message ,detail.type.indexOf("empty") );
              if (detail.type.indexOf('empty') > 0) {
                emptyFlags[val] = true;
              }
              const mt = detail.message.match(/\[(.*)\]/i);
              const _regex = detail.type.match(/regex/i);
              let ms = '';
              // eslint-disable-next-line no-unused-vars
              let _key = '';
              if (_regex) {
                let _pattern = '';
                _.each(regex.pattern, (value, key) => {
                  if (`${value}` == `${detail.context.pattern}`) {
                    _pattern = key;
                    _key = key;
                  }
                });
                ms = regex.message[_pattern];
              } else {
                if (mt) {
                  if (
                    mt[1] == 'string_base' ||
                    mt[1] == 'string_min' ||
                    mt[1] == 'string_max'
                  ) {
                    // eslint-disable-next-line no-unused-vars
                    const mt2 = detail.message.match(/\[(.*)\](d+)/i);
                    ms = `${detail.context.limit}${localizeMessage[mt[1]]}`;
                  } else {
                    ms = `${localizeMessage[mt[1]]}`;
                  }
                }
              }

              if (this.getFormListElement(this.getFormElementByName(val))) {
                const component = this.getFormListElement(
                  this.getFormElementByName(val)
                );
                if (component.querySelector('.form-list__alert')) {
                  const message = component.querySelector('.form-list__alert');
                  //空表示を優先する
                  if (!emptyFlags[val]) {
                    message.classList.add('show');
                    if (mt && component) {
                      message.innerText = ms ? ms : localizeMessage[mt[1]];
                    } else if (ms && component) {
                      message.innerText = ms;
                    }
                  } else {
                    if (mt && component) {
                      message.classList.add('show');
                      message.innerText = localizeMessage['empty'];
                    }
                  }
                  //console.log("@@@@@ ",val,emptyFlags[val] , _.clone(_key) , ms ,detail.message );
                }
              }

              counter++;
            });
          });
          return false;
        }
        return true;
      }

      /**
       * 合計表示更新
       * @param {object} data
       * @param {object} optionalRequired {tel:true}
       */
      // eslint-disable-next-line no-unused-vars
      validateCounter(data, optionalRequired) {}

      /**
       * 成否をかえす
       */
      // eslint-disable-next-line no-unused-vars
      validate(data, optionalRequired) {
        // console.log('formUtil.js validate', data);
        // eslint-disable-next-line no-unused-vars
        let counter = 0;
        let keys = [];
        const result = Joi.validate(data, this.schema, {
          abortEarly: false,
          language: localize,
        });
        if (result.error) {
          result.error.details.forEach(detail => {
            // eslint-disable-next-line no-unused-vars
            _.each(detail.path, val => {
              if (keys.indexOf(detail.path[0]) < 0) {
                _.each(this.validate_value, (value, key) => {
                  if (
                    value._flags.presence &&
                    _.includes(value._flags.presence, 'required')
                  ) {
                    if (key == detail.path[0]) {
                      keys.push(detail.path[0]);
                      counter++;
                    }
                  }
                });
              }
            });
          });
        }
      }

      /**
       * フォーム値をデフォルトパラメータで絞り込む
       * @param {collection} json
       * @param {collection} def
       * */

      mergeParam(json, def) {
        let param = {};
        _.each(def, (val, key) => {
          _.each(json, (jval, jkey) => {
            if (key == jkey) {
              param[key] = jval;
            }
          });
        });
        return param;
      }

      /**
       * フォームの並び替えを設定
       * @param {*} _props
       */
      setOrder(_props) {
        //フォーム並び替え用に.form-listをflex化
        const formList = this.document.querySelector('.form-list');
        formList.style.display = 'flex';
        formList.style.flexDirection = 'column';

        _.each(this.forms, (inputobject, key) => {
          const order = _.filter(_props.view.order, _order => {
            return _order.name === key;
          });
          if (order.length) {
            inputobject.setOrder(order[0].order);
          } else {
            inputobject.setOrder(null);
          }
        });
      }

      /**
       * フォーム要素を取得
       */
      getValue(func) {
        //再帰で全フォームの値を取得
        let tags = [];
        const req = (element, _tags) => {
          if (!element || !element.children.length) {
            return;
          }
          _.each(element.children, elm => {
            if (elm.children) {
              if (elm.name) {
                _tags.push({ name: elm.name, el: elm });
                req(elm, _tags);
              }
              req(elm, _tags);
            } else {
              if (elm.name) {
                _tags.push({ name: elm.name, el: elm });
              }
            }
          });
        };

        req(this.document.querySelector('.form-list'), tags);
        let params = {};
        _.each(tags, tag => {
          params[tag.name] = tag.el.value;
        });

        let col = _.map(_.cloneDeep(params), (val, key) => {
          return [key.split('--'), val];
        });

        let json = {};
        _.each(_.cloneDeep(col), val => {
          json[val[0].shift()] = [];
        });
        _.each(_.cloneDeep(params), (val, key) => {
          const mt = key.match(/^(.*)--([0-9])--(.*)/);
          if (mt) {
            if (json[mt[1]][mt[2]]) {
              json[mt[1]][mt[2]][mt[3]] = val;
            } else {
              json[mt[1]][mt[2]] = {};
              json[mt[1]][mt[2]][mt[3]] = val;
            }
          } else {
            json[key] = val;
          }
        });

        if (func) {
          func(json);
        }
      }

      //単純に.sys-name付与されたフォームの値を取得
      getValueFromSysName(func) {
        let json = {};
        _.each(this.document.querySelectorAll('.sys-name'), val => {
          json[val.name] = val.value;
        });
        if (func) {
          func(json);
        }
      }

      /**
       * 依存関係を設定
       */
      setConstraint(list, callback) {
        class Constraint {
          constructor(val, form) {
            this.param = val;
            this.form = form;
            this.callback;
          }

          init() {
            this.enable(false);
            this.addMemberEvent();
            //ドロップダウンイベント受け取る
            EventMg.addEventListener(EventType.DROPDOWN_MENU, () => {
              this.detect();
            });
          }

          setCallback(callback) {
            this.callback = callback;
          }

          enable(b) {
            if (this.form.getFormElementByName(this.param.name)) {
              this.form.getFormElementByName(this.param.name).disabled = b;
            }
            if (callback) {
              callback(this.param.name, b);
            }
          }

          addMemberEvent() {
            _.each(this.param.member, member => {
              if (this.form.getFormElementByName(member[0])) {
                this.form
                  .getFormElementByName(member[0])
                  .addEventListener('change', () => {
                    this.detect();
                  });
              }
            });
            this.detect();
          }

          getType(sel) {
            const elem = this.form.getFormElementByName(sel);
            if (!_.has(elem, 'type')) {
              return false;
            }

            if (elem.type === 'text') {
              return elem.value ? true : false;
            } else if (elem.type === 'checkbox') {
              return elem.checked ? true : false;
            } else if (elem.type === 'raido') {
              return elem.checked ? true : false;
            } else if (elem.type === 'select-one') {
              return elem.value ? true : false;
            } else if (elem.type === 'select-multiple') {
              return elem.value ? true : false;
            } else if (elem.type === 'textarea') {
              return elem.value ? true : false;
            }
          }

          detect() {
            let counter = 0;
            _.each(this.param.member, member => {
              const b = member[1] === 'true' ? true : false;
              if (b === this.getType(member[0])) {
                counter++;
              }
            });
            this.enable(counter === this.param.member.length ? false : true);
          }
        }

        //ボタンクラスのコンストレイン
        class ClassConstraint extends Constraint {
          constructor(val, form) {
            super();
            this.param = val;
            this.form = form;
          }

          enable(bool) {
            this.form.document.querySelector(
              `.${this.param.buttonClass}`
            ).disabled = bool;
          }
        }

        this.constraintList = [];
        _.each(list, val => {
          if (val) {
            if (_.has(val, 'buttonClass')) {
              //ボタン
              const element = new ClassConstraint(val, this);
              element.init();
              element.setCallback(callback);
              this.constraintList.push(element);
            } else {
              //フォーム要素
              const element = new Constraint(val, this);
              element.init();
              element.setCallback(callback);
              this.constraintList.push(element);
            }
          }
        });
      }

      /**
       *
       */
      getFormListElement(element) {
        const selecter = 'form-list__item';

        if (!element) {
          return null;
        } else if (element.classList.contains(selecter)) {
          return element;
        } else {
          return this.getFormListElement(element.parentElement);
        }
      }
    };
  };
};

/**
 * Joiだけでは処理できないチェック
 *
 * TODO：
 * アカウント詳細画面(UserProfileForm): UI/UX改善済み
 * 初回ログイン時のアカウント詳細(InvitedUserProfileForm)：未改善
 *
 * 上記両方にUI/UX改善が入った段階でpassword_confirmationのテキスト修正する
 *
 * @param {*} schema スキーマ
 * @param {*} params パラメータ
 * @returns
 */
export const runExtendJoi = (schema, params) => {
  const result = validationRegexByJoi(schema, params);
  const messages = result.messages || {};

  // 値がから文字ではないとき
  if (params['password'] && params['current_password']) {
    if (params['password'] !== params['password_confirmation']) {
      messages['password_confirmation'] =
        '新しいパスワードと、新しいパスワード（再入力）が一致しません。';
      result.status = false; // エラーにする
      result.messages = messages;
    }

    // パスワード変更は既存パスワードと同じならエラーにする。
    if (params['password'] === params['current_password']) {
      messages['password'] =
        '現在のパスワードと同じにはできません。パスワードを変更してください。';
      result.status = false; // エラーにする
      result.messages = messages;
    }
  }

  return result;
};



// WEBPACK FOOTER //
// ./src/utilities/formUtil.js